module.exports = __webpack_public_path__ + "media/images/lb/215-c412b4cc972f15d96f3293d3272edabe.svg";